import { InputNumber, type InputNumberProps } from 'primereact/inputnumber';
import type { LiliInputBaseProps } from '../../types/LiliInputBaseProps';
import { LiliFloatingLabel } from '../LiliFloatingLabel/LiliFloatingLabel';
import { textInputStyle } from '../../util/styling';
import { useFontClass } from '../../tokens';

export interface LiliNumberInputProps
  extends LiliInputBaseProps, Omit<InputNumberProps, 'onChange' | 'id' | 'onBlur' | 'onFocus'> {
  value?: number | null;
  mode?: 'decimal' | 'currency';
  currency?: string;
  maxFractionDigits?: number;
  onChange: (value: number | null) => void;
  suffix?: string;
  prefix?: string;
  min?: number;
  max?: number;
  maxLength?: number;
}

export const LiliNumberInput = ({
  title,
  id,
  value,
  mode,
  currency,
  errorMessage,
  onBlur,
  onFocus,
  onChange,
  maxFractionDigits = 2,
  disabled,
  suffix,
  prefix,
  min,
  max,
  maxLength,
  tabIndex,
  isPublic,
  placeholder,
  ...otherProps
}: LiliNumberInputProps) => {
  const { fontClass } = useFontClass();

  return (
    <LiliFloatingLabel
      id={id}
      label={title}
      onClear={() => onChange(null)}
      errorMessage={errorMessage}
      disabled={disabled}>
      {/* Full API: https://primereact.org/inputnumber/  */}
      <InputNumber
        inputClassName={textInputStyle(fontClass, value, disabled)}
        className='w-full'
        placeholder={title ? ' ' : placeholder}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(event) => onChange(event.value)}
        onValueChange={(event) => {
          onChange(event.value ?? null);
        }}
        inputId={id}
        mode={mode}
        currency={currency}
        maxFractionDigits={maxFractionDigits}
        disabled={disabled}
        suffix={suffix}
        prefix={prefix}
        min={min}
        max={max}
        maxLength={maxLength}
        tabIndex={tabIndex}
        {...(!isPublic && { 'data-private': 'lipsum' })}
        {...otherProps}
      />
    </LiliFloatingLabel>
  );
};
